async function handleQuickAdd(e) {
  
  if (e.classList.contains('is-disabled') || e.classList.contains('has-success')) {
    return;
  }

  // cart upsell
  const loader = document.querySelector('[data-cart-loading]');
  const loadbar = loader.querySelector('.item--loadbar');
  // default
  const wrapper = e.closest('[data-quick-add]');

  var selectedProducts = [];
  var qty = wrapper && wrapper.querySelector('[data-quantity-input]') ? wrapper.querySelector('[data-quantity-input]').value : 1;
  var variantId = parseFloat(e.dataset.addToCartVariant);
  var sellingPlan = e.dataset.sellingPlan ? parseFloat(e.dataset.sellingPlan) : null;
  var commissionable = e.dataset.quickAddToCartCommissionable;
  var taxable = e.dataset.quickAddToCartTaxable || 'true';
  var avalaraUdfProperties = window.jafraBuildAvalaraUdfPropertiesFromElement
    ? window.jafraBuildAvalaraUdfPropertiesFromElement(e)
    : {};

  selectedProducts = [{
    id: variantId,
    quantity: qty,
    selling_plan: sellingPlan,
    properties: {
      _commissionable: commissionable,
      _taxable: taxable,
      ...avalaraUdfProperties
    }
  }]

  var formData = {
    'items': selectedProducts
  }

  if (selectedProducts.length > 0) {
    e.classList.add('loading');
    e.classList.add('is-disabled');
    if (loader) {
      loadbar.style.display = 'block';
      loader.classList.add('cart--loading');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then((response) => {
      e.classList.remove('loading');
      e.classList.remove('is-disabled');
      e.classList.add('has-success');

      setTimeout(() => {
        e.classList.remove('has-success');
        reloadCart(response.data);
        openDrawer();
        if (loader) {
          loadbar.style.display = 'none';
          loader.classList.remove('cart--loading');
        }
      }, 1500);
    })
    .catch(err => {
      console.error(err);
    })
  }
}

function reloadCart(data) {
  document.dispatchEvent(
    new CustomEvent("theme:cart:change", {
      detail: {
        cart: data,
      },
      bubbles: true,
    })
  );
  document.dispatchEvent(
    new CustomEvent('theme:cart:init', {
      bubbles: true
    })
  );
  document.dispatchEvent(
    new CustomEvent("theme:cart:reload", {
      detail: {
        cart: data,
      },
      bubbles: true,
    })
  );
}

function openDrawer() {
  const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
  const modal = document.querySelector('[data-product-modal-container]');

  if (modal && modal.classList.contains('is-visible')) return;

  if (!cartDrawer.classList.contains('drawer--visible')) {
    cartDrawer.dispatchEvent(
      new CustomEvent('theme:drawer:open', {
        bubbles: true,
      })
    );
  }
}
